<template>
  <div class="cards">
    <card
      @click.native="handleCardClick(card.title)"
      v-for="card in cards"
      :key="card.id"
      :title="card.title"
      :image="card.image"
    />
  </div>
</template>

<script>
import Card from '@/components/community/Card';
/*
 * navigation of community. it is consisted
 * of tickets, polls and members. will grow
 * in the future
 * */
export default {
  components: {
    Card
  },
  data() {
    return {
      spinnerShow: false,
      cards: [
        {
          id: 6,
          title: 'Objave',
          image: 'far fa-newspaper'
        },
        {
          id: 1,
          title: 'Tiketi',
          image: 'fas fa-ticket-alt'
        },
        {
          id: 2,
          title: 'Glasanja',
          image: 'far fa-chart-bar'
        },
        {
          id: 3,
          title: 'Detalji',
          image: 'fa fa-users'
        },
        {
          id: 4,
          title: 'Događaji',
          image: 'far fa-calendar-alt'
        }
        // {
        //   id: 5,
        //   title: 'Blagajna',
        //   image: 'fas fa-cash-register'
        // },
        // {
        //   id: 7,
        //   title: 'Dokumenta',
        //   image: 'fas fa-file-alt'
        // }
      ]
    };
  },
  methods: {
    handleCardClick(title) {
      this.spinnerShow = true;
      switch (title) {
        case 'Tiketi':
          this.$router.push({
            name: 'communityTickets'
          });
          break;
        case 'Glasanja':
          this.$router.push({
            name: 'communityPolls'
          });
          break;
        case 'Detalji':
          this.$router.push({
            name: 'communityMembers'
          });
          break;
        case 'Događaji':
          this.$router.push({
            name: 'communityEvents'
          });
          break;
        case 'Blagajna':
          this.$router.push({
            name: 'communityFinancesHome'
          });
          break;
        case 'Objave':
          this.$router.push({
            name: 'communityPosts'
          });
          break;
        case 'Dokumenta':
          this.$router.push({
            name: 'communityDocuments'
          });
          break;
      }
    }
  }
};
</script>

<style scoped>
.cards {
  display: flex;
  justify-content: center;
  padding-top: 10%;
  flex-wrap: wrap;
}
</style>
